var _templateObject = _taggedTemplateLiteralLoose(['\n  font-family: Inter;\n  margin-bottom: 0px;\n  background-color: #1D295B;\n  font-size: 16px;\n  padding: 0 15px;\n  min-height: 40px;\n  .container {\n    width: auto;\n  };\n  border: 0px;\n  border-radius: 0px;\n  .navbar-nav>li {\n    border-left: 1px solid #F8F8FF;\n  }\n  .navbar-nav>li>a {\n    color: #F8F8FF !important;\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n  #apex-online-menu {\n    border-right: 1px solid #F8F8FF;\n  }\n  #service-center-icon {\n    vertical-align: middle;\n    height: 15px;\n    margin-right: 8px;\n  }\n  #sign-icon {\n    vertical-align: middle;\n    height: 15px;\n    margin-left: 8px;\n  }\n'], ['\n  font-family: Inter;\n  margin-bottom: 0px;\n  background-color: #1D295B;\n  font-size: 16px;\n  padding: 0 15px;\n  min-height: 40px;\n  .container {\n    width: auto;\n  };\n  border: 0px;\n  border-radius: 0px;\n  .navbar-nav>li {\n    border-left: 1px solid #F8F8FF;\n  }\n  .navbar-nav>li>a {\n    color: #F8F8FF !important;\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n  #apex-online-menu {\n    border-right: 1px solid #F8F8FF;\n  }\n  #service-center-icon {\n    vertical-align: middle;\n    height: 15px;\n    margin-right: 8px;\n  }\n  #sign-icon {\n    vertical-align: middle;\n    height: 15px;\n    margin-left: 8px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: 0.85em;\n  padding: 15px 5px 5px 5px;\n  box-shadow: 2px 2px 10px 0 #666666;\n  background-color: #f2f2f2;\n  div {\n    display: flex;\n  }\n  ul {\n    padding: 10px;\n    // IE needs us to set flex-basis here\n    flex-basis: 300px;\n    min-width: calc(90vw/9);\n    line-height: 16px;\n    li {\n      padding-top: 5px;\n      display: flex;\n      flex-grow: 1;\n      &.list-title {\n        font-weight: 500;\n        color: #4079BC;\n        border-bottom: 1px solid #1d295b;\n        padding-bottom: 2px;\n      };\n      a {\n        color: #1d295b;\n        padding: 5px;\n        margin: -5px;\n        &:hover {\n          background-color: #dcdcdc;\n          text-decoration: none;\n          border-radius: 2px;\n          padding: 5px;\n          margin-left: -5px;\n          margin-right: -5px;\n        }\n      }\n    }\n  }\n  div.new-tools-container {\n    flex-direction: column;\n    min-width: calc(90vw/9);\n    line-height: 16px;\n    ul {\n      flex-basis: auto;\n      min-width: 120px;\n      margin-top: 10px;\n      border: 1px solid #999999;\n      border-radius: 5px;\n      background-color: white;\n      height: auto;\n    }\n  }\n  @media (max-width: 960px) {\n    max-width: 200px;\n    div {\n      display: block;\n      &.new-tools-container {\n        margin-top: 20px;\n      }\n    }\n  }\n  div.new-tools-container:nth-child(2) {\n    padding-left: 10px;\n  }\n'], ['\n  font-size: 0.85em;\n  padding: 15px 5px 5px 5px;\n  box-shadow: 2px 2px 10px 0 #666666;\n  background-color: #f2f2f2;\n  div {\n    display: flex;\n  }\n  ul {\n    padding: 10px;\n    // IE needs us to set flex-basis here\n    flex-basis: 300px;\n    min-width: calc(90vw/9);\n    line-height: 16px;\n    li {\n      padding-top: 5px;\n      display: flex;\n      flex-grow: 1;\n      &.list-title {\n        font-weight: 500;\n        color: #4079BC;\n        border-bottom: 1px solid #1d295b;\n        padding-bottom: 2px;\n      };\n      a {\n        color: #1d295b;\n        padding: 5px;\n        margin: -5px;\n        &:hover {\n          background-color: #dcdcdc;\n          text-decoration: none;\n          border-radius: 2px;\n          padding: 5px;\n          margin-left: -5px;\n          margin-right: -5px;\n        }\n      }\n    }\n  }\n  div.new-tools-container {\n    flex-direction: column;\n    min-width: calc(90vw/9);\n    line-height: 16px;\n    ul {\n      flex-basis: auto;\n      min-width: 120px;\n      margin-top: 10px;\n      border: 1px solid #999999;\n      border-radius: 5px;\n      background-color: white;\n      height: auto;\n    }\n  }\n  @media (max-width: 960px) {\n    max-width: 200px;\n    div {\n      display: block;\n      &.new-tools-container {\n        margin-top: 20px;\n      }\n    }\n  }\n  div.new-tools-container:nth-child(2) {\n    padding-left: 10px;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  z-index: 1000;\n  list-style: none;\n  #apex-online-menu-dropdown {\n    color: white;\n    display: flex;\n    background-color: #1D295B;\n    text-decoration: none;\n    border-right: 1px solid #F8F8F8;\n    border-color: white;\n    .title {\n      padding-left: 7px;\n    }\n  }\n  .open>a {\n    color: white;\n  }\n  \n  .dropdown-menu {\n    padding: 0;\n    margin: 9px 0 0 -17px;\n  }\n'], ['\n  position: relative;\n  z-index: 1000;\n  list-style: none;\n  #apex-online-menu-dropdown {\n    color: white;\n    display: flex;\n    background-color: #1D295B;\n    text-decoration: none;\n    border-right: 1px solid #F8F8F8;\n    border-color: white;\n    .title {\n      padding-left: 7px;\n    }\n  }\n  .open>a {\n    color: white;\n  }\n  \n  .dropdown-menu {\n    padding: 0;\n    margin: 9px 0 0 -17px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  color: black;\n  a {\n    padding: 0 !important;\n  }\n'], ['\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  color: black;\n  a {\n    padding: 0 !important;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import { NavDropdown, MenuItem, Navbar, Nav, NavItem } from 'react-bootstrap';
import styled from 'styled-components';
import { FaTimes, FaBars, FaHome, FaQuestionCircle, FaSignOutAlt, FaSignInAlt } from 'react-icons/fa';
import TableMenu from './TableMenu';
import { NEW_TOOLS_COLUMNS } from './constants';
import { buildLegacyMenu, buildToolsItems, setAllowedPermissions } from './permissionsHelper';

var StyledNavbar = styled(Navbar)(_templateObject);
var StyledTableMenuWrapper = styled.div(_templateObject2);

var StyledNavDropdown = styled(NavDropdown)(_templateObject3);

var StyledCloseItem = styled(MenuItem)(_templateObject4);

export var ApexOnlineMenu = function ApexOnlineMenu(_ref) {
  var items = _ref.items,
      userPermissions = _ref.userPermissions,
      accountNumber = _ref.accountNumber,
      legacyUrl = _ref.legacyUrl,
      showLogout = _ref.showLogout,
      logout = _ref.logout;

  var titleElement = React.createElement(
    'span',
    null,
    React.createElement(FaBars, null),
    React.createElement(
      'span',
      { className: 'title' },
      'Apex Online Menu'
    )
  );
  var allowedPermissions = setAllowedPermissions(userPermissions.permissions);
  var newToolsLinks = buildToolsItems(allowedPermissions, accountNumber);
  var legacyItems = buildLegacyMenu(items, legacyUrl);
  var allItems = [].concat(legacyItems, newToolsLinks);
  return React.createElement(
    StyledNavbar,
    null,
    React.createElement(
      Nav,
      { pullLeft: true },
      React.createElement(
        NavItem,
        { href: '/session/#/welcome' },
        React.createElement(FaHome, {
          style: {
            color: '#F8F8FF'
          }
        })
      ),
      React.createElement(
        StyledNavDropdown,
        {
          noCaret: true,
          title: titleElement,
          id: 'apex-online-menu-dropdown',
          disabled: !showLogout
        },
        React.createElement(
          StyledTableMenuWrapper,
          { id: 'test-id-menu-wrapper' },
          React.createElement(TableMenu, {
            items: allItems,
            newToolsColumns: NEW_TOOLS_COLUMNS
          })
        ),
        React.createElement(
          StyledCloseItem,
          null,
          React.createElement(FaTimes, { id: 'apex-online-menu-close-icon' })
        )
      )
    ),
    React.createElement(
      Nav,
      { pullRight: true },
      showLogout && React.createElement(
        React.Fragment,
        null,
        React.createElement(
          NavItem,
          {
            href: 'https://apexclearing.zendesk.com/hc/en-us',
            target: '_blank',
            rel: 'noreferrer'
          },
          React.createElement(FaQuestionCircle, { id: 'service-center-icon' }),
          'Help'
        ),
        React.createElement(
          NavItem,
          {
            onClick: logout
          },
          'Sign Out',
          React.createElement(FaSignOutAlt, { id: 'sign-icon' })
        )
      ),
      !showLogout && React.createElement(
        NavItem,
        {
          href: '/'
        },
        'Sign In',
        React.createElement(FaSignInAlt, { id: 'sign-icon' })
      )
    )
  );
};

ApexOnlineMenu.propTypes = process.env.NODE_ENV !== "production" ? {
  items: PropTypes.arrayOf(PropTypes.shape({
    parentHeader: PropTypes.string,
    label: PropTypes.string,
    href: PropTypes.string,
    linkId: PropTypes.string
  })),
  userPermissions: PropTypes.object.isRequired,
  accountNumber: PropTypes.string,
  legacyUrl: PropTypes.string.isRequired,
  logout: PropTypes.func.isRequired,
  showLogout: PropTypes.bool.isRequired
} : {};

ApexOnlineMenu.defaultProps = {
  items: [],
  accountNumber: ''
};

export default ApexOnlineMenu;